// Module
var code = "<select ng-model=\"vm.model\" class=\"b-select\" ng-options=\"option.id as option.name for option in vm.options\"></select> ";
// Exports
module.exports = code;